import { Modal } from "@/components/ui/Modal";
import { Spinner } from "@/components/ui/Spinner";
import { useHandoverProtocols } from "../hooks/useAssetRegistry";
import { ProtocolCard } from "./ProtocolCard";

interface Props {
  open: boolean;
  onClose: () => void;
}

export function MyProtocolsModal({ open, onClose }: Props) {
  const { data: protocols = [], isLoading } = useHandoverProtocols(undefined, open);

  return (
    <Modal open={open} onClose={onClose} title="Moje protokoły przekazania" size="lg">
      {isLoading ? (
        <div className="py-8 flex justify-center">
          <Spinner />
        </div>
      ) : protocols.length === 0 ? (
        <p className="text-sm text-[var(--color-text-muted)] py-6 text-center">
          Nie złożyłeś jeszcze żadnego wniosku.
        </p>
      ) : (
        <div className="space-y-3">
          {protocols.map((p) => (
            <ProtocolCard key={p.id} protocol={p} />
          ))}
        </div>
      )}
    </Modal>
  );
}
